import { h } from "preact";
import Router, { RoutableProps } from "preact-router";
import { baseUrl, route } from "../../App";
import { SidraLEGOrder } from "./sidra-leg-order";
import { SidraLEGSerialNumber } from "./sidra-leg-serial-number";
import "./styles.scss";
import { SidraLEGReprint } from "./sidra-leg-reprint";
import { SidraLEGTabletFlash } from "./sidra-leg-tablet-flash";

function SidraLEGHome(props: RoutableProps) {
    return <div class="orion-sit-page">
        <h1 style="text-align: center; font-size: 30px; margin-top: 10px;">Wybierz akcje</h1>
        <div class="paper action-list">
            <div class="product-list" style="margin-top: 10px;">
                <div class="action-button" onClick={() => route("/sidra-leg/tablet-flash")}>
                    <span class="icon">developer_board</span>
                    <div class="action">Zaprogramuj tablet</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/sidra-leg/serial-number")}>
                    <span class="icon">confirmation_number</span>
                    <div class="action">Wygeneruj numery seryjne</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/sidra-leg/reprint")}>
                    <span class="icon">view_agenda</span>
                    <div class="action">Wydrukuj naklejkę dla istniejącego numeru</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/sidra-leg/order")}>
                    <span class="icon">post_add</span>
                    <div class="action">Stwórz zestawienie</div>
                    <span class="icon">chevron_right</span>
                </div>
                <div class="action-button" onClick={() => route("/order")}>
                    <span class="icon">list_alt</span>
                    <div class="action">Pokaż zestawienia</div>
                    <span class="icon">chevron_right</span>
                </div>
            </div>
        </div>
    </div>;
}

export function SidraLEG(props: RoutableProps) {
    return <Router>
        <SidraLEGHome path={`${baseUrl}/sidra-leg`}/>
        <SidraLEGSerialNumber path={`${baseUrl}/sidra-leg/serial-number`}/>
        <SidraLEGReprint path={`${baseUrl}/sidra-leg/reprint`}/>
        <SidraLEGOrder path={`${baseUrl}/sidra-leg/order`}/>
        <SidraLEGTabletFlash path={`${baseUrl}/sidra-leg/tablet-flash`} />
    </Router>
}
